import { Controller } from "@hotwired/stimulus"

// Surface B section editor (Phase B — dense section list).
//
// Mirrors corner-editor: the section list is a flat list of dense single-line
// rows, each with an always-visible name <input> inside its own PATCH form. The
// only piece that has to be focus-safe is committing a rename.
//
// Why focus-safety matters: a rename PATCH returns the Turbo Stream that
// REPLACES the whole #track_sections_card (so the header counters stay
// truthful). If the input committed on every keystroke, that swap would rip the
// focused field out mid-type. So we commit only on `change` (which fires after
// the field loses focus) and turn Enter into a blur — by the time the request
// goes out, focus has already left the field and the swap is safe.
export default class extends Controller {
  // The card carries the track's fresh sections_json. The corner-curation parent
  // holds this card as an outlet and, on every card replace, reads this value to
  // re-sync the timeline + map section layer in place (Phase F). It's a passive
  // data carrier here — section-editor itself only needs the rename commit logic.
  static values = { sections: Array }

  // Commit the inline name form. Bound to `change` on the input — fires once the
  // field has lost focus, so the subsequent card replace can't steal focus.
  submitName(event) {
    event.target.closest("form")?.requestSubmit()
  }

  // Enter commits via blur: blurring fires `change`, which submits. This keeps a
  // single commit path and guarantees focus is gone before the Turbo swap.
  blurOnEnter(event) {
    event.preventDefault()
    event.target.blur()
  }
}
